import { Component } from "react";
import ApiManager from "../../../managers/ApiManager";
import {
  DKLabel,
  DKCheckMark,
  showToast,
  TOAST_TYPE,
} from "deskera-ui-library";

class VideoSectionEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }

  render() {
    return (
      <div
        className={`column parent-width border-box mt-m border-radius-s p-r border-m shadow-s ${
          this.props.className || ""
        }`}
      >
        <DKLabel text="Video URL" className="fw-m" />
        <input
          className="parent-width border-box p-s bg-gray1 border-radius-s mt-r border-m text-blue mb-l"
          type="text"
          value={this.componentData.value.videoURL}
          onChange={(e) => this.onChangeValue("videoURL", e.target.value)}
          placeholder="https://www.youtube.com/..."
        />

        {/* Temporarily hiding the option to overlay custom thumbnail, due to current htmlGenerator limitations.. 
        <DKLabel text="Upload Thumbnail Image" className="fw-m mb-m" />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => this.uploadImageToAWS(e.target.files[0])}
        />

        <DKLine style={{ height: 3 }} className="m-v-xl" /> */}

        <DKCheckMark
          title="Enable Autoplay"
          isSelected={this.componentData.value.autoplayEnabled}
          onClick={(e) => {
            e?.stopPropagation && e.stopPropagation();
            this.onChangeValue(
              "autoplayEnabled",
              !this.componentData.value.autoplayEnabled
            );
          }}
          className="text-black fw-m"
        />
      </div>
    );
  }

  onChangeValue = (key, newValue) => {
    console.log(key, newValue);
    const newComponentData = { ...this.componentData.value };
    newComponentData[key] = newValue;
    this.componentData.value = newComponentData;
    this.props.onDataChange(this.componentData);
  };

  uploadImageToAWS = (imageData) => {
    ApiManager.getUploadFileURL(
      imageData,
      (url) => this.onChangeValue("videoThumbnail", url),
      (err) => {
        showToast("Image upload failed", TOAST_TYPE.FAILURE);
      }
    );
  };
}

export default VideoSectionEditor;
